var collapsible_list_pair_rtlignore_default = {
  "container": "Bi38t",
  "title": "XkxKL",
  "viewerContainer": "_6VQqp",
  "titleContainer": "Dhtzk",
  "expandIcon": "Jx6pb",
  "dndIcon": "-iWPK",
  "RTL": "_0n8OP",
  "LTR": "XVV0n",
  "itemContainer": "KxOwr",
  "itemContainerViewer": "_6524q",
  "mouseDown": "KRz7m",
  "innerEditor": "_5Me7U",
  "item": "YYF9y",
  "floatingAddPluginMenuWrapper": "rJPMl",
  "childrenHidden": "-I0uf"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
